// Regiao de Estudo
// import Fuse from 'fuse.js'
import theapi from '@/api.js'
// import * as turf from '@turf/turf'

import nearestPointToLine from '@turf/nearest-point-on-line';
import length from '@turf/length'
import lineSliceAlong from '@turf/line-slice-along'
import lineSlice from '@turf/line-slice'
// import lineDistance from '@turf/distance'
// import {featureCollection} from '@turf/feature-collection'
import {featureCollection} from '@turf/helpers';

var turf = {
    length,
    lineSliceAlong,
    lineSlice,
    nearestPointToLine,
    lineDistance:length,
    featureCollection
}

// turf.along = _.along; //my along with elevation

export default function(data) {

    var API_percurso = theapi.percurso;

    var state = {
        geoJSON:false, // original json
        courses:false, //{'key',courseGeoJSON}
        kms:false, // { 'key':'kmsGeoJSON'}
        checkpoints:false, //{'key':checkpointsGeoJSON }
        editionID:-1,
        editionList:false,
        actualRace:1,
        actualCourseLeg:false,
        races:[], //{kms,checkpoints,course, start,end,geoJSON}

    }

    return {
        state: state,

        //--MUTATIONS
        mutations: {          
            setPercursoState: function(state, obj) {
                _.each(obj,(v,k)=>{
                    state[k] = v;
                })
            },

            geoJSON: function(state, geoJSON) {
                state.geoJSON = geoJSON;
            },

            actualCourseLeg: function(state, leg){
                state.actualCourseLeg = leg
            }
        },


        //--ACTIONS
        actions: {

            loadPercurso: function(ctx, editionID) {

                if(ctx.state.geoJSON === false){
                        var url = API_percurso+"?v=2";
                        var params = {}
                        if(editionID){
                            ctx.commit('setPercursoState',{editionID})
                            params.id = editionID
                        }
                        console.log("Start Loading percursoJSON");
                        $.getJSON(url, params, geoJSON => {
                          
                            console.log("percursoJSON %o",geoJSON);
                            ctx.commit('geoJSON', {...geoJSON});
                            ctx.dispatch('processGeoJSON')
                        });
                }

            },


            processGeoJSON:function(ctx){
                
                var geoJSON = JSON.parse(JSON.stringify(ctx.state.geoJSON));

                var courses = _.find(geoJSON.features, (feature) => feature.geometry.type == "LineString");
                var mainCourse = courses;
                var totalDistance = turf.length(courses);

                ctx.commit('setPercursoState',{courses})

                var checkpoints = _.filter(geoJSON.features, (feature) => _.get(feature, 'properties._storage_options.tipotrecho', '') == "trecho")
                var checkpointsWithInfo = processCheckPoints(checkpoints,courses)
             
                var checkpointsCollection = turf.featureCollection(checkpointsWithInfo)   
                ctx.commit('setPercursoState',{checkpoints:{...checkpointsCollection}})

                var coursesAvaliables =  _.filter(geoJSON.features, (feature) => _.get(feature, 'properties._storage_options.tipotrecho', '') == "percurso");
                
                var races = [];
                _.each(coursesAvaliables, (course, index)=>{
                        var name = _.get(course, 'properties.name', '');
                        var distance = parseInt(_.get(course, 'properties._storage_options.distancia', ''));
                        var startAt = parseInt(_.get(course, 'properties._storage_options.kminicio', ''));
                        var endAt = startAt+distance;
                        
                        var race = {name,distance}
                        race.id = index;
                        race.geoJSON = course;
                        race.course = turf.lineSliceAlong(mainCourse, startAt, endAt);
                        race.kms = generateKmsGeoJson(race.course);
                        

                        var checkpoints2 = _.filter(JSON.parse(JSON.stringify(geoJSON.features)), (feature) => _.get(feature, 'properties._storage_options.tipotrecho', '') == "trecho")
                        // var checkpointsWithInfo2 = processCheckPoints(checkpoints2,courses)

                        var checkpointsOfRace = _.filter({...checkpointsWithInfo}, checkpoint=> checkpoint.properties.km >= startAt );
                        //if i do not have a start checkpoint, need to create it, using information from tipotrecho
                        if(startAt < checkpointsOfRace[0].properties.km > 0){

                                var checkpointStart;
                            //LETODO - checkpoint start
                            //     const pi = checkpoints[index];
                            //     const piEnd = checkpoints[index + 1];
                            // 
                                var startPoint = _.along(race.course,0);
                                var endPoint = _.along(race.course, checkpointsOfRace[0].properties.km-startAt);

                                let trechoLine = turf.lineSlice(startPoint, endPoint, race.course);
                                trechoLine.properties = course.properties;
                                trechoLine.properties.distance = turf.lineDistance(trechoLine);
                                trechoLine.properties.km = 0;

                               trechoLine.properties = {...trechoLine.properties, ...trechoLine.properties._storage_options }
                                
                               var checkpoints =  _.map(checkpointsOfRace,ck=>{
                                //    ck.properties.km = ck.properties.km - startAt;
                                    var obj = {...ck}
                                    obj.properties.km = obj.properties.km - startAt;

                                   return obj; //{...ck, properties.km:ck.properties.km - startAt};
                               })

                               checkpointsOfRace = [trechoLine,...checkpoints];
                        }

                        race.checkpoints = {...turf.featureCollection(checkpointsOfRace)};
                        races.push(race);
                })

                races.sort((a, b) => b.kms.features.length - a.kms.features.length);
                console.log("races %o",races);
                ctx.commit('setPercursoState',{races});
                ctx.commit('setPercursoState',{actualRace:0});

                var kms = generateKmsGeoJson(courses);
                ctx.commit('setPercursoState',{kms})

             
            }


        },


        //--GETTERS
        getters: {

            kms: state => getRaceInfo(state,"kms"),

            courses: state => getRaceInfo(state,"course"), //state.races[state.actualRace].courses || false,

            checkpointsGeoJson: state => getRaceInfo(state,"checkpoints"), //state.races[state.actualRace].checkpoints || false,
            
            checkpoints: state => getRaceInfo(state,"checkpoints.features"), //state.races[state.actualRace].checkpoints || false,
            
            checkpointsCourses: (state,getters) => {
                //remove the last point it is the finith checkpoint
                if(getters.checkpoints == false) return [];
                var checkpoints = [...getters.checkpoints];
                if(_.isArray(checkpoints))
                        checkpoints.pop();
                        
                return checkpoints;
            }, 
            races: state => state.races,

            currentRace: state => _.get(state.races,`[${state.actualRace}]`, false),
        
            currentRaceName: state => getRaceInfo(state,"name"),
        
            currentCourseLeg: state => getRaceInfo(state,`checkpoints.features[${state.actualCourseLeg}]`),

            pointFromDistance: (state,getters) => (km) =>{
                //get the current course
                var course = getters.courses
                // get point geoJSON
                var point = _.along(course,km)
                return point
            }

        },

    }
}



var getRaceInfo = function(state,key){

    return _.get(state.races,`[${state.actualRace}].${key}`, false)

}

var generateKmsGeoJson = function(lineFeature){
        var distance = turf.lineDistance(lineFeature);
        var points = lineFeature.geometry.coordinates;
        var coords = [];

        for (var i = 1; i < distance; i++) {
            var point = _.along(lineFeature, i);
            _.set(point, 'properties.name', i)
            coords.push(point)
        }

        var kmsGeoJson = turf.featureCollection(coords);
        return kmsGeoJson;
}






var processCheckPoints = function(checkpoints,courses) {

        var trechosLines = [],
             trechosArrayForStore = [];

        debugger;
        _.each(checkpoints,ck=>{
                var numero = ck.properties._storage_options.numero;
                // if( ! abertura.match(/\d\dh/g)){
                    ck.properties._storage_options.numero = parseInt(numero,10);
                // }
            }
        );

        //checkpoints sorted
        checkpoints = _.sortBy(checkpoints,'properties._storage_options.numero');

        var currentDistance = 0;
        //loop each pis
        for (let index = 0; index < checkpoints.length - 1; index++) {
            
            const pi = checkpoints[index];
            const piEnd = checkpoints[index + 1];
            
            var startPoint = nearestPointToLine(courses, pi.geometry.coordinates);
            var endPoint = nearestPointToLine(courses, piEnd.geometry.coordinates);

            let trechoLine = turf.lineSlice(startPoint, endPoint, courses);
            trechoLine.properties = pi.properties;
            trechoLine.properties.distance = turf.lineDistance(trechoLine);
            
            trechoLine.properties.km = currentDistance;
            currentDistance += trechoLine.properties.distance;
            
            //put _storage_options information used pa gui of map in properties
            trechoLine.properties = {...trechoLine.properties, ...trechoLine.properties._storage_options }

            trechosLines.push(trechoLine)
        }

        //process last endpoint, the finishline

        let trechoLine = checkpoints[checkpoints.length-1];
        trechoLine.properties = trechoLine.properties;
        trechoLine.properties.km = turf.lineDistance(courses);
        trechoLine.properties.distance = 0;
        trechoLine.properties = {...trechoLine.properties, ...trechoLine.properties._storage_options }
        trechosLines.push(trechoLine)

        return trechosLines;
    }